@if (titleIconClass) {
    <vn-icon extraClass="d-flex align-items-center" size="16" [name]="titleIconClass" />
}
@if (title) {
    <span class="header-text">{{ title }}</span>
}
